module.exports = __webpack_public_path__ + "static/Chicory2-ccdeb3a11eda0083d28be738f7c262c2.png";